import { TFunction } from "i18next";

import { activeShopFidelity } from "../helpers";

type Deps = {
    row: FidelityRow;
    userID: number;
    franchiseID: string;
    operatorID: string;
    uuidUser: string | null;
    fetchGlobal: FetchGlobal;
    setDataIsUpdated: (v: boolean) => void;
    t: TFunction;
};

export function useActivateFidelity(deps: Deps) {
    return () =>
        activeShopFidelity({
            row: deps.row,
            userID: deps.userID,
            franchiseID: deps.franchiseID,
            operatorID: deps.operatorID,
            uuidUser: deps.uuidUser,
            fetchGlobal: deps.fetchGlobal,
            t: deps.t,
            setDataIsUpdated: deps.setDataIsUpdated,
        });
}
